import styled, { css } from "styled-components";
import { color, focusRing, hoverColor, onHover, units } from "@m/alchemy-theme";
import { IconButton } from "../icon-button/IconButton";
export const CloseButton = styled(IconButton) `
  width: ${units(3)};
  height: ${units(3)};
  margin: 0;

  transition: color 0.2s ease-in;
  color: ${color("base")};

  svg {
    color: currentColor;
  }

  ${onHover(css `
    // TODO replace with token value
    color: ${hoverColor("base")};
  `)}

  @media (forced-colors) {
    box-shadow: inset 0 0 0 1px ButtonBorder;
    color: ButtonText;

    ${onHover(css `
      color: ButtonText;
    `)}

    &:focus {
      ${focusRing({ type: "native" })}
    }
  }
`;
